module.exports = new __parcel__URL__("gra2pes.958e723e.png").toString();